import UpdateUser from '@/services/users/UpdateUser';
import FetchUserData from '@/services/users/userService/FetchUserData';
import FetchSkipDeliveryReasons from '@/services/users/userService/FetchSkipDeliveryReasons';
import SendSkipDeliveryReasons from '@/services/users/userService/SendSkipDeliveryReasons';
import FetchStripeSetupIntent from '@/services/users/userService/FetchStripeSetupIntent';
import FetchStripeTerminalToken from '@/services/users/userService/FetchStripeTerminalToken';
import FetchPromotionalBanners from '@/services/users/userService/FetchPromotionalBanners';
import GetOutstandingOrders from '@/services/users/userService/GetOutstandingOrders';
import PayOutstandingOrders from '@/services/users/userService/PayOutstandingOrders';
import FetchThemes from '@/services/users/userService/FetchThemes';
import UpdateFeature from '@/services/users/userService/UpdateFeature';

export default class UserService {
    fetchUserData(isCanvasser) {
        return (new FetchUserData()).handle(isCanvasser);
    }

    fetchSkipDeliveryReasons() {
        return (new FetchSkipDeliveryReasons()).handle();
    }

    sendSkipDeliveryReasons(subscriptionId, payload) {
        return (new SendSkipDeliveryReasons()).handle(subscriptionId, payload);
    }

    updateUser(payload) {
        return (new UpdateUser()).handle(payload);
    }

    fetchStripeSetupIntent(payload) {
        return (new FetchStripeSetupIntent()).handle(payload);
    }

    fetchStripeTerminalToken() {
        return (new FetchStripeTerminalToken()).handle();
    }

    fetchPromotionalBanners() {
        return (new FetchPromotionalBanners()).handle();
    }

    getOutstandingOrders(userId) {
        return (new GetOutstandingOrders()).handle(userId);
    }
    payOutstandingOrders(userId, payload) {
        return (new PayOutstandingOrders()).handle(userId, payload);
    }

    fetchThemes() {
        return (new FetchThemes()).handle();
    }

    updateFeature(userId, payload) {
        return (new UpdateFeature()).handle(userId, payload);
    }
}
